import emailjs from '@emailjs/browser';

// Initialize EmailJS with your public key
emailjs.init("BIPsjHpzPymTldPwr");

const sendConfirmationEmail = async (reservationData) => {
  try {
    const { name, email, date, duration, tableName, paymentMethod, total } = reservationData;

    if (!email) {
      console.error("❌ No email found in reservation data");
      return;
    }

    // Convert duration to a readable time range
    const getTimeFromDuration = (duration) => {
      switch (duration) {
        case 'breakfast': return '7:00 AM - 11:00 AM';
        case 'lunch': return '12:00 PM - 4:00 PM';
        case 'dinner': return '6:00 PM - 11:00 PM';
        default: return 'TBD';
      }
    };

    const timeSlot = getTimeFromDuration(duration);

    // Format date to something like "Sunday, July 27, 2025"
    const formattedDate = new Date(date).toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });

    // Capitalize duration text (Breakfast, Lunch, Dinner)
    const durationText = duration 
      ? duration.charAt(0).toUpperCase() + duration.slice(1) 
      : 'TBD';

    // Add conditional note for cash payments
    const paymentNote = paymentMethod === 'cash' 
      ? `Please pay ${total} LE at the restaurant when you arrive.` 
      : '';

    // EmailJS variables (must match your EmailJS template fields)
    const emailData = {
      email: email,
      user_name: name,
      date: formattedDate,
      time_slot: timeSlot,
      duration: durationText,
      table_name: tableName,
      restaurant_name: "Tuscany House",
      payment_note: paymentNote
    };

    console.log("📧 Sending email with data:", emailData);

    const response = await emailjs.send(
      "service_jhqf5ks",       // Your EmailJS Service ID
      "template_snkzjf9",      // Your EmailJS Template ID
      emailData                // Variables passed to template
    );

    console.log("✅ Email sent successfully!", response.status);
  } catch (error) {
    console.error("❌ Email sending failed:", error);
    console.error("Error details:", {
      status: error.status,
      text: error.text,
      response: error.response
    });
  }
};

export default sendConfirmationEmail;